export default "__VITE_ASSET__Cv5wy_Hs__"